import { BASE_IMPORT_DATA } from "@/Modals/WebDataManagement/MasterData/BaseImport/baseImportData";

import React from "react";
import { columns } from "./Columns";
import { teamsMasterDataApi, sportsMasterDataApi } from "@/apis/apis";
import { FILTER_TYPE } from "@/constant/constants";
import { useNavigate } from "react-router-dom";
import { useGet } from "@/apiHooks/HttpFunctions";
import { LIST_MODE } from "@/constant/Lists/listMode";
import { STATUS } from "@/constant/statusConstants";
import { AddIcon } from "@/constant/imagePath";
import BaseTable from "./BaseTable";

export default function TeamsPage() {
  const navigate = useNavigate();

  const { data: sportData } = useGet({
    apiURL: sportsMasterDataApi,
    params: {
      mode: LIST_MODE.ALL,
      status: STATUS.ACTIVE,
      sort: "order",
    },
  });
  const sportOptions = [
    { value: "", label: "All" },
    ...(sportData?.data?.map((item) => {
      return {
        value: item.code,
        label: item.code,
      };
    }) || []),
  ];
  return (
    <BaseTable
      label="Team"
      apiURL={teamsMasterDataApi}
      columns={columns()}
      statusColumn="status"
      importData={BASE_IMPORT_DATA.TEAMS}
      enableSortData={true}
      enableAdd={false}
      customEditFn={({ id }) => navigate(`${id}/edit`)}
      additionalFilters={[
        {
          id: "filter[sport.code]",
          label: "Sport ID",
          type: FILTER_TYPE.SELECT,
          options: sportOptions,
        },
      ]}
      confirmationModalTitleKey={(item) => item.default_title}
      customHeaderActionsData={[
        {
          label: "Add",
          onClick: () =>
            navigate("/web-data-management/master-data/teams/create"),
          icon: () => <img src={AddIcon} className="h-4" alt="Add Player" />,
          backgroundColor: "golden-gradient",
        },
      ]}
    />
  );
}
